import { connect } from 'react-redux';
import NotificationsSettings from './NotificationsSettings';
import {
  getNotificationsSettings,
  saveNotificationsSettings,
} from '../../redux/profileNotifications/actions';
import {
  selectNotificationsSettings,
  selectNotificationsSettingsLoading,
  selectNotificationsSettingsUpdating,
} from 'modules/Profile/redux/profileNotifications/selectors';

const mapStateToProps = (state) => ({
  settings: selectNotificationsSettings(state),
  isLoading: selectNotificationsSettingsLoading(state),
  isUpdating: selectNotificationsSettingsUpdating(state),
});
const mapDispatchToProps = { getNotificationsSettings, saveNotificationsSettings };

export default connect(mapStateToProps, mapDispatchToProps)(NotificationsSettings);
